import script from "./PrivacyModal.vue?vue&type=script&setup=true&lang=js"
export * from "./PrivacyModal.vue?vue&type=script&setup=true&lang=js"

import "./PrivacyModal.vue?vue&type=style&index=0&id=6a9a002b&lang=scss"
import "./PrivacyModal.vue?vue&type=style&index=1&id=6a9a002b&lang=scss&scoped=true"

import exportComponent from "/home/build/jenkins/workdir/workspace/fast-build/fast-build/67161/vshow-main/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a9a002b"]])

export default __exports__